import { get } from '@eika-infrastruktur/request';
import type { AccountForChildEligibilityDetails } from '@generated-types';
import { getApiUrl } from '../utils';

export const getChildEligibilities = (): Promise<AccountForChildEligibilityDetails[]> =>
    get(getApiUrl('eligibility-details'));
